<div *ngIf="!isInEditMode" class="portfolio-name">
  <span class="name">{{ portfolio?.name }}</span>
  <a class="btn btn-default btn-sm" (click)="onEditPortfolioNameClick()"
    ><i class="fa fa-pencil fa-fw"></i
  ></a>
</div>
<div class="portfolio-name" *ngIf="isInEditMode">
  <span>{{ 'label.Name' | translate }}</span>
  <input maxlength="50" type="text" [(ngModel)]="newName" />
  <hr-field-state-marker [field]="field?.newName"></hr-field-state-marker>
  <a class="btn btn-default btn-sm" (click)="onUpdatePortfolioNameClick()"
    ><i class="fa fa-check fa-fw"></i
  ></a>
  <a class="btn btn-default btn-sm" (click)="onCancelClick()"
    ><i class="fa fa-times fa-fw"></i
  ></a>
</div>
